export default __webpack_public_path__ + "static/media/armchair_example.7bf22906.jpg";